module.exports = __webpack_public_path__ + "img/ambiente.1a7a6081.png";